import {
  BONUS_BUTTON_MODAL_VIEWED, BONUS_BUTTON_MODAL_CLOSED,
  BONUS_BUTTON_POPUP_VIEWED, BONUS_BUTTON_POPUP_EXPANDED, BONUS_BUTTON_POPUP_COLLAPSED,
} from '../actions/types';

const VALUE_NOT_SET = '(not set)';

export const bonusButtonGaActionEvents = {
  /* Modal */
  [BONUS_BUTTON_MODAL_VIEWED]: () => ({
    category: 'Button Install Bonus',
    action: 'Lightbox View',
    label: VALUE_NOT_SET,
    value: 1,
  }),
  [BONUS_BUTTON_MODAL_CLOSED]: () => ({
    category: 'Button Install Bonus',
    action: 'Lightbox Close',
    label: VALUE_NOT_SET,
    value: 1,
  }),
  /* Popup */
  [BONUS_BUTTON_POPUP_VIEWED]: ({ isQualified, leftAmount }) => ({
    category: 'Button Install Bonus',
    action: 'Pop-up View',
    label: isQualified ? `Post-install | ${leftAmount}` : 'Pre-install',
    value: 1,
  }),

  [BONUS_BUTTON_POPUP_EXPANDED]: ({ isQualified }) => ({
    category: 'Button Install Bonus',
    action: 'Collapsed Pop-up Expand',
    label: isQualified ? 'Post-install' : 'Pre-install',
    value: 1,
  }),

  [BONUS_BUTTON_POPUP_COLLAPSED]: ({ isQualified }) => ({
    category: 'Button Install Bonus',
    action: 'Pop-up Collapse',
    label: isQualified ? 'Post-install' : 'Pre-install',
    value: 1,
  }),
};

export const bonusButtonClickAndHoverEvents = [
  /* Modal */
  {
    selector: '.mn_bonusButtonModal .mn_getButton',
    click: {
      category: 'Button Install Bonus',
      action: 'Lightbox Click',
      value: 1,
    },
    label: VALUE_NOT_SET,
  },
  /* Popup */
  {
    selector: '.mn_bonusButtonPopup.mn_preInstall .mn_getButton',
    click: {
      category: 'Button Install Bonus',
      action: 'Pop-up Click',
      value: 1,
    },
    label: 'Pre-install',
  },
  {
    selector: '.mn_bonusButtonPopup.mn_postInstall .mn_getButton',
    click: {
      category: 'Button Install Bonus',
      action: 'Pop-up Click',
      value: 1,
    },
    label: (element) => {
      const { leftAmount } = element.dataset;
      return `Post-install | ${leftAmount}`;
    },
  },
];
